export default __webpack_public_path__ + "static/media/logo-troyagang.2b4b9544.svg";